import {
  Avatar,
  Breadcrumb,
  Button,
  Col,
  Dropdown,
  Image,
  Row,
  Tabs,
  TabsProps,
  Tag,
} from "antd";
import {
  AngleRight,
  ContractsIcon,
  DeleteIcon,
  NeedHelp,
} from "../../../atoms/CustomIcons";
import DashboardTemplate from "../../../templates/Dashboard";
import Dashboard from "./ProfileTabs/Dashboard";
import Deals from "./ProfileTabs/Deals";
import Tasks from "./ProfileTabs/Tasks";
import Schedule from "./ProfileTabs/Schedule";
import WorkOrders from "./ProfileTabs/WorkOrders";
// import TakeOff from "./ProfileTabs/TakeOff";
import Invoices from "./ProfileTabs/Invoices";
import ProfileSidebar from "./Components/Sidebar";
import { useState } from "react";
import { MoreOutlined } from "@ant-design/icons";
import TakeOffStatic from "./ProfileTabs/TakeOffStatic";
import DummyData from "../property-data.json";

export default function PropertyProfile() {
  const [fullWidth, setFullWidth] = useState(false);

  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const propertyId = pathSegments[pathSegments.length - 2];
  const companyId = pathSegments[pathSegments.length - 1];

  let dummyData = DummyData.find((x) => x.id === propertyId);

  if (!dummyData) {
    dummyData = DummyData[0];
  }
  const tabItems: TabsProps["items"] = [
    {
      key: "1",
      label: "Dashboard",
      children: <Dashboard data={dummyData.property.dashboard} />,
    },
    {
      key: "2",
      label: "Deals",
      children: <Deals data={dummyData?.property.deals} />,
    },
    {
      key: "3",
      label: "Work orders",
      children: <WorkOrders data={dummyData?.property.workOrders} />,
    },
    {
      key: "4",
      label: "Tasks",
      children: <Tasks data={dummyData?.property.tasks} />,
    },
    {
      key: "5",
      label: "Schedule",
      children: <Schedule />,
    },
    {
      key: "6",
      label: "Takeoff",
      children: <TakeOffStatic />,
    },
    {
      key: "7",
      label: "Invoices",
      children: <Invoices />,
      disabled: true,
    },
  ];

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/save-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          New deal
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/change-user.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Change account responsible
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/reset-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Transfer to another client
        </Button>
      ),
    },
    {
      key: "4",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Edit details
        </Button>
      ),
    },
    {
      key: "5",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/archive-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Archive
        </Button>
      ),
    },
    {
      key: "6",
      label: (
        <Button
          type="text"
          className="delete-hover"
          icon={<DeleteIcon />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  return (
    <>
      <DashboardTemplate loading={false}>
        <div className="profileHeader">
          <div className="headerLeft">
            <Breadcrumb
              separator={<AngleRight />}
              style={{ marginBottom: "12px" }}
            >
              <Breadcrumb.Item>
                <a href={`/properties/${companyId}`}> Properties </a>
              </Breadcrumb.Item>

              <Breadcrumb.Item>Property profile</Breadcrumb.Item>
            </Breadcrumb>

            <div className="headerContentWithImage">
              <Avatar
                size={74}
                className="avatarColor"
                shape="square"
                src={dummyData.property.image}
                style={{ borderRadius: "100px" }}
              />

              <div>
                <h2
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "8px",
                    marginBottom: "8px",
                  }}
                >
                  {dummyData.property.name}
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                    }}
                  >
                    {dummyData.property.category?.map(
                      (x: { name: string; color: string }) => {
                        return <Tag className={x.color}> {x.name} </Tag>;
                      }
                    )}
                  </span>
                </h2>

                <div
                  style={{ display: "flex", gap: "16px", alignItems: "center" }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "4px",
                      alignItems: "center",
                    }}
                  >
                    <Image
                      src="/images/estimate/clients-icon.svg"
                      style={{ width: "16px", height: "16px" }}
                      preview={false}
                    />
                    <span
                      style={{
                        fontSize: "14px",
                        lineHeight: "20px",
                        fontWeight: "400",
                        color: "#474C4D",
                      }}
                    >
                      {dummyData.property.client_name}
                    </span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      gap: "4px",
                      alignItems: "center",
                    }}
                  >
                    <Image
                      src="/images/estimate/pin_location.svg"
                      style={{ width: "16px", height: "16px" }}
                      preview={false}
                    />
                    <span
                      style={{
                        fontSize: "14px",
                        lineHeight: "20px",
                        fontWeight: "400",
                        color: "#474C4D",
                      }}
                    >
                      {dummyData.property.address}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="two_btns">
            <Button htmlType="submit" size="large" className="btn-sm">
              <NeedHelp /> Need help?
            </Button>
          </div>
        </div>

        <div className="headerRight" style={{ marginTop: 32 }}>
          <Button
            htmlType="button"
            type="default"
            size="large"
            className="outlined-btn"
            style={{ marginRight: "8px" }}
          >
            Notes & activity
          </Button>

          <Dropdown
            menu={{ items }}
            trigger={["click"]}
            placement="bottomRight"
            className="actionButton"
          >
            <Button
              onClick={(x) => {
                x.stopPropagation();
              }}
              onKeyDown={(e) => e.stopPropagation()}
              style={{
                padding: "0px",
                height: "36px",
                width: "36px",
                backgroundColor: "transparent",
                border: "1px solid #DEE5E6",
                borderRadius: "8px",
              }}
              className="only_icon"
              icon={<MoreOutlined />}
            />
          </Dropdown>
        </div>

        <div className="profileContent">
          <Row gutter={[16, 16]} wrap={false}>
            <Col flex="auto" className="TabsArea">
              <Tabs
                defaultActiveKey="1"
                items={tabItems}
                className="profileTabs"
                tabBarExtraContent={
                  <Button
                    className="only_icon"
                    style={{ marginLeft: 8 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setTimeout(
                        () => {
                          setFullWidth(!fullWidth);
                        },
                        fullWidth ? 100 : 0
                      );
                    }}
                    icon={
                      <Image
                        preview={false}
                        src="/images/profile/profile-fullWidth.svg"
                      />
                    }
                  />
                }
              />
            </Col>
            <Col
              flex={fullWidth ? "46px" : "360px"}
              className="rightSideBar"
              style={{ transition: "0.35s" }}
            >
              {fullWidth ? (
                <div className="fullWidthIconWrapper">
                  <Button
                    className="only_icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      setTimeout(
                        () => {
                          setFullWidth(!fullWidth);
                        },
                        fullWidth ? 100 : 0
                      );
                    }}
                    icon={<ContractsIcon />}
                  />
                </div>
              ) : (
                <ProfileSidebar
                  data={{
                    notes: dummyData?.property?.noteForCrew,
                    documents: dummyData?.property?.documents.folders,
                    preferredVisitTime: dummyData?.property?.preferredVisitTime,
                  }}
                />
              )}
            </Col>
          </Row>
        </div>
      </DashboardTemplate>
    </>
  );
}
